import { FC } from "react";
import { Web3ReactProvider } from "@web3-react/core";

import { useWeb3 } from "../../hooks";
import Routes from "../../routes";

type Props = unknown;

const Web3Provider: FC<Props> = () => {
  return (
    <Web3ReactProvider getLibrary={useWeb3}>
      <Routes />
    </Web3ReactProvider>
  );
};

export default Web3Provider;
